export default {
  setFirstBreadcrumb({ commit }, item) {
    commit('setFirstBreadcrumb', item)
  },
  setFirstBreadcrumbByRoute({ commit }, route) {
    commit('setFirstBreadcrumb', {
      key: route.name,
      name: route.meta.title,
    })
  },
  pushItemBreadcrumb({ commit }, item) {
    commit('pushItemBreadcrumb', item)
  },
  navBackBreadcrumb({ commit }, key) {
    commit('navBackBreadcrumb', key)
  },
  popBreadcrumbItem({ commit }) {
    commit('popBreadcrumbItem')
  },
  resetBreadcrumb({ commit }) {
    commit('resetBreadcrumb')
  },
  hardResetBreadcrumb({ commit }) {
    commit('hardResetBreadcrumb')
  },
}
